import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'
import { updateTicket } from '../../actions/trackNumber'
import { connect } from 'react-redux'

export class CheckBox extends Component {

  handleChangeCheckBox = event => {

    const { id, updateTicket } = this.props
    updateTicket(id, {
      is_document: event.target.checked
    })

  }

  render() {
    const { username, is_document } = this.props
    return (
      <FormControlLabel
        disabled={!username === 'admin'}
        control={
          <Checkbox
            checked={is_document}
            onChange={this.handleChangeCheckBox}
            value="checked"
            color="primary"
          />
        }
      />
    )
  }
}

const styles = theme => {

}

export default connect((state => ({
  username: state.auth.username,
})), dispatch => ({ updateTicket: (id, jData) => dispatch(updateTicket(id, jData)) }),
)(withStyles(styles)(CheckBox))



// WEBPACK FOOTER //
// ./src/components/FormComponent/CheckBox.js